// Copy for a request that never got an answer. One rule for fetch and Apollo.
export const GENERIC_ERROR = 'Something went wrong. Please try again.'
export const OFFLINE_ERROR =
  'You appear to be offline. Check your connection and try again.'

export const isOffline = (): boolean =>
  typeof navigator !== 'undefined' && navigator.onLine === false

export const transportFailureCopy = (offline = isOffline()): string =>
  offline ? OFFLINE_ERROR : GENERIC_ERROR
